module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/product-model-4-2779dc6e04d0bfa07807ad5ea644b881.jpg";